'use client'
import CustomerReviews from '@/components/UI/Shared/Reviews/CustomerReviews'
import { Box, Divider, styled, SxProps, Theme, Typography } from '@mui/material'
import { colors } from '@/Theme/LegacyTheme'
import ThreeColImageHeadingText from '@/UI/Layout/ThreeColImageHeadingText'
import ResponsiveImage from '@/UI/MUI/ResponsiveImage/ResponsiveImage'
import { blueBoxThreeColData, threeColData } from './content'
import CTOLetter from './CTOLetter'

const StyledBlueBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  border: `1px solid ${colors.blue}`,
  padding: theme.spacing(5),
  h3: {
    color: colors.blue
  }
}))

const StyledSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(8),
  paddingTop: theme.spacing(5),
  textAlign: 'center'
}))

const centeredWidth = (md: string): SxProps<Theme> => ({
  mx: 'auto',
  width: { xs: '100%', md }
})

const PageContent = () => {
  return (
    <>
      <CTOLetter />

      <StyledSection component="section">
        <Typography variant="h1" component="h2" align="center">
          What&apos;s important to us
        </Typography>
        <StyledBlueBox>
          <ThreeColImageHeadingText
            data={blueBoxThreeColData}
            headerComponent="h3"
            headerVariant="h2"
          />
        </StyledBlueBox>
      </StyledSection>

      <StyledSection component="section">
        <ThreeColImageHeadingText data={threeColData} headerComponent="h3" headerVariant="h2" />
      </StyledSection>

      <Divider sx={{ my: 6 }} />

      <StyledSection component="section" sx={centeredWidth('80%')}>
        <Typography variant="h1" component="h2">
          How we work
        </Typography>
        <Typography variant="h2" component="h3" color={colors.accessibleBlue}>
          Working with lenders
        </Typography>
        <Typography variant="bodyLarge" component="p">
          We compare a wide range of trusted lenders, to help find you the best car finance deal
          from our panel without charging you a penny in fees. Our range of lenders cover the whole
          market, and our soft search technology means we can get you an initial finance decision in
          seconds without impacting your credit score.
        </Typography>
        <ResponsiveImage
          aspectRatio="1 / 0.45"
          sx={{ my: 6, mx: 'auto', maxWidth: '580px' }}
          src="https://cdn.zuto.cloud/assets/images/about-zuto/mobile/audi.png"
          alt="Audi"
          loading="eager"
        />
        <Typography variant="h2" component="h3" color={colors.accessibleBlue}>
          Choose the right car
        </Typography>
        <Typography variant="bodyLarge" component="p">
          Whether you&apos;ve already found a vehicle or you want to browse our network of verified
          dealers, we&apos;ll run a free vehicle and history check for you. If you buy a car from
          one of our trusted dealers, this means they&apos;ve passed our quality and service
          standards so you can buy with peace of mind.
        </Typography>
      </StyledSection>

      <Divider sx={{ my: 6 }} />

      <StyledSection component="section" sx={centeredWidth('50%')}>
        <Typography variant="h1" component="h2">
          Our customers
        </Typography>
        <Typography variant="bodyLarge" component="p">
          We&apos;ve helped over 450,000 customers secure car finance and we&apos;re proud to be
          rated ‘excellent’ on Trustpilot. Customers are at the heart of everything we do at Zuto,
          and providing a seamless service is what we&apos;re passionate about.
        </Typography>
        <Typography variant="bodyLarge" component="p">
          Read what some of our customers thought about their Zuto experience here
        </Typography>
      </StyledSection>

      <Box component="section" sx={centeredWidth('50%')}>
        <CustomerReviews />
      </Box>
    </>
  )
}

export default PageContent
